module.exports = __webpack_public_path__ + "img/imgZXGH(24).8a5c7a6e.png";